import type { BankQueryParam, CustomerBank, UpdateBankForm } from "../../../../common/types/customerBank";
import httpRequest from ".";

// 项目管理
class CustomerBankService {
    private readonly path: string;
    private service: any;

    constructor(path: string, service: any) {
        this.path = path;
        this.service = service;
    }

    /** 分页查询 */
    public async findByCustomerId(params: BankQueryParam): Promise<CustomerBank[]> {
        const { data } = await this.service.get(`${this.path}/findByCustomerId`, { params });
        return data;
    }

    /** 获取详情 */
    async getInfo(id: number | string): Promise<CustomerBank> {
        const { data } = await this.service.get(`${this.path}/${id}?isUpdate=${!!id}`);
        return data;
    }
    async update(id: number | string, params: UpdateBankForm) {
        await this.service.put(`${this.path}/${id}`, params);
    }
    async delById(id: number | string) {
        await this.service.delete(`${this.path}/${id}`);
    }
    async create(params: UpdateBankForm) {
        await this.service.post(`${this.path}`, params);
    }
}
export const customerBankService = new CustomerBankService("/customer/bank", httpRequest);
